import React from 'react';
import { useRouter } from 'next/router';
import { OnboardingProvider } from './OnboardingContext';
import { OnboardingContainer } from './OnboardingContainer';
import { BusinessLine, Video } from '../../../types/definitions/vendor/graphql-schema.d';
import { OnboardingStatus } from '../OnboardingStatus';
export type SupportedBusinessLine = Extract<BusinessLine, 'MENS' | 'WOMENS'>;
export const Onboarding = ({
  businessLine,
  video,
  onboardingStatus
}: {
  businessLine: SupportedBusinessLine;
  video?: Video;
  onboardingStatus?: string | null;
}) => {
  const router = useRouter();
  const hasNotYetOnboarded = onboardingStatus === OnboardingStatus.NOT_YET_ONBOARDED;
  if (!hasNotYetOnboarded) {
    router.replace('/gallery');
  }
  return <OnboardingProvider>
      <OnboardingContainer businessLine={businessLine} video={video} />
    </OnboardingProvider>;
};